import React from "react";
import LottoRow from "./LottoRow";

const LottoRows = (props) => {

    const createRows = (rows) => {
        return rows.map((row, rowNr) => {
            return (
                <LottoRow 
                    toggleEditor={(isExpanded) => props.toggleEditor(rowNr, isExpanded)} 
                    isExpanded={props.isExpanded}
                    compactOnly={props.compactOnly}
                    editorOpen={row.editorOpen} 
                    onClickNumber={(number, nrType) => {props.onClickNumber(rowNr, number, nrType)}}
                    onDelete={() => props.onDelete(rowNr)}
                    onRandom={() => props.onRandom(rowNr)}
                    gameType={props.gameType} 
                    row={row}
                    key={rowNr}
                    rowNr={rowNr}
                    kenoCount={props.kenoCount}>
                </LottoRow>
            );
        });
    };
    return (
        <div >
            {createRows(props.rows)}
        </div>
    );
};

export default LottoRows;